import * as THREE from 'three';

export interface FlightParams {
  origin: THREE.Vector3;
  velocity: THREE.Vector3;
  gravity?: number;
  drag?: number;
}

export class FlightSim {
  position = new THREE.Vector3();
  velocity = new THREE.Vector3();
  alive = false;
  private gravity = 4.5;
  private drag = 0.12;

  spawn(p: FlightParams): void {
    this.position.copy(p.origin);
    this.velocity.copy(p.velocity);
    this.gravity = p.gravity ?? 4.5;
    this.drag = p.drag ?? 0.12;
    this.alive = true;
  }

  reset(): void {
    this.alive = false;
    this.velocity.set(0, 0, 0);
  }

  step(dt: number): void {
    if (!this.alive) return;

    this.velocity.x -= this.velocity.x * this.drag * dt;
    this.velocity.z -= this.velocity.z * this.drag * dt;
    this.velocity.y -= this.gravity * dt;

    this.position.addScaledVector(this.velocity, dt);
  }

  orient(target: THREE.Object3D): void {
    if (this.velocity.lengthSq() < 0.001) return;
    const lookAt = this.position.clone().add(this.velocity);
    target.lookAt(lookAt);
    target.rotateY(Math.PI);
  }
}
